import styled from 'styled-components';
import TabButtonGray from '../TabButtonGray';

const TabButtonPurple = styled(TabButtonGray)`
  color: #5646ff;
`;
export default TabButtonPurple;
